module.exports = __webpack_public_path__ + "img/qu_sa.6aba229.jpg";